export const MONTHS = {
  'Jan': " يناير ",
  'Feb': " فبراير ",
  'Mar': "مارس",
  'Apr': "أبريل",
  'May': "مايو",
  'Jun': " يونيو ",
  'Jul': "يوليو",
  'Aug': "أغسطس",
  'Sep': "سبتمبر",
  'Oct': "أكتوبر",
  'Nov': "نوفمبر",
  'Dec': "ديسمبر",
};

export const AM_PM = {
  AM: "صباحاً",
  PM: "مساءً",
};

export const WEEKDAYS = {
  'Sun':	'الأحد',
  'Mon':	'الإثنين',
  'Tue':	'الثلاثاء',
  'Wed':	'الأربعاء',
  'Thu':	'الخميس',
  'Fri':	'الجمعة',
  'Sat':	'السبت'
}
